/**
 * @return {string}
 */
export default function getPortfolioName() {
  return window?.$dt?.objConfig.PortfolioName || '';
}
